import type { RootState } from '@/store/root-reducer';

const selectListDetail = (state: RootState) => state.listDetail;

export const selectList = (state: RootState) => selectListDetail(state).list;
export const selectProfiles = (state: RootState) => selectListDetail(state).profiles;
export const selectCompanies = (state: RootState) => selectListDetail(state).companies;
export const selectRemovedProfiles = (state: RootState) => selectListDetail(state).removedProfiles;
export const selectCommentCount = (state: RootState) => selectListDetail(state).commentCount;
export const selectLoadStatus = (state: RootState) => selectListDetail(state).loadStatus;
export const selectMutation = (state: RootState) => selectListDetail(state).mutation;
export const selectDedupe = (state: RootState) => selectListDetail(state).dedupe;
export const selectDeleted = (state: RootState) => selectListDetail(state).deleted;
export const selectDuplicate = (state: RootState) => selectListDetail(state).duplicate;
